export default "__VITE_ASSET__CbNA94FC__"